/**
 * Resolved table block: dark header, sort, CSV, collapse after 15 rows.
 */
import { renderDataTable } from './data-table.js';
import { resolvedOf } from './shape.js';

/**
 * @param {object} block
 * @param {{ onAsk?: Function }} [actions]
 * @returns {HTMLElement}
 */
export function renderTable(block, actions) {
  const data = resolvedOf(block);
  return renderDataTable({
    type: 'table',
    id: block && block.id,
    title: data.title || '',
    columns: Array.isArray(data.columns) ? data.columns : [],
    rows: Array.isArray(data.rows) ? data.rows : [],
    totals: data.totals,
    sortable: data.sortable === true,
    truncated: data.truncated,
    shown: data.shown,
    note: data.note ? String(data.note) : '',
    actions,
    askTitle: data.title || '',
  });
}
